/* ============
 * Send reminder
 * ============
 *
 * Send reminder
 */

import Vue from 'vue';

export default (id, params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`bills/payment_reminder/${id}`, params)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.response);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/sendReminder.js